import { useOpenStateStore } from '../stores/OpenStateStore';

export function useTailorHasOpened() {
  const hasOpened = useOpenStateStore((state) => state.hasOpened);
  const setHasOpened = useOpenStateStore((state) => state.setHasOpened);

  return { hasOpened, setHasOpened };
}
